<template>
  <div
    :id="id"
    class="modal s-modal--success"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content align-items-center">
        <div class="modal-header">
          <div class="modal-title">
            <div><i class="icon-check-circle"></i></div>
            <div>{{ title }}</div>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close">
            <i class="icon-close-light"></i>
          </button>
        </div>
        <div class="modal-body alignt-center" v-html="text"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      required: true,
      type: String,
    },
    title: {
      required: true,
      type: String,
    },
    text: {
      required: true,
      type: String,
    },
  },
}
</script>
